<div
    #postingsRef
    [attr.postId]="postingResource.id"
    class="slide swiper-slide"
    [ngClass]="hoverPositionClass"
    (click)="openPostInDialog()"
    (mouseenter)="onMouseEnter(postingResource, $event)"
    (mouseleave)="onMouseLeave($event)"
    (mousemove)="onMouseMove($event)"
    (keyup.enter)="onMouseEnter(postingResource, $event); onMouseMove($event)"
    (keyup.escape)="onMouseLeave($event)"
>
    <div class="slide-wrapper">
        <div class="slide-img-container" (click)="openPostingUrl(postingResource)">
            <div class="slide-img-layer"></div>
            <div class="slide-img scale" *ngIf="postingResource.isUsingDefaultImage !== true" [style.background-image]="'url(' + postingResource.image.smallUrl + ')'"></div>
            <div class="slide-img scale no-image" *ngIf="postingResource.isUsingDefaultImage === true">
                <mat-icon class="bg-icon" aria-hidden="true" svgIcon="bg_illustration"> </mat-icon>
            </div>
            <div class="slide-content">
                <mat-chip-set tabIndex="-1">
                    <mat-chip class="accent-500" [disableRipple]="true">{{ postingResource.postingType.displayNameKeySingular | translate }}</mat-chip>
                </mat-chip-set>
                <h3 class="mt-4 mb-0" tabindex="0" attr.aria-label="{{ 'GENERAL.BUTTON.OPEN' | translate }} {{ postingResource.translation.title }}">
                    {{ postingResource.translation.title | translate }}
                </h3>
                <span class="tile-metadata mt-4" tabindex="0" *ngIf="postingResource.isBooked; else visibleOptionsCount">
                    <mat-icon class="tile-metadata-icon">check_circle</mat-icon>
                    {{ 'GENERAL.LABEL.BOOKED' | translate }}
                </span>
                <ng-template #visibleOptionsCount>
                    <span
                        class="tile-metadata mt-4"
                        tabindex="0"
                        *ngIf="postingResource.kind === 'course_category' && postingResource.numberOfPublishedOfferings !== null"
                    >
                        {{ 'GENERAL.LABEL.VISIBLE_COURSES_COUNT' | translate: { count: postingResource.numberOfPublishedOfferings } }}
                    </span>
                    <span class="tile-metadata mt-4" tabindex="0" *ngIf="postingResource.kind !== 'course_category'">
                        {{ 'GENERAL.LABEL.VISIBLE_EXECUTIONS_COUNT' | translate: { count: postingResource.numberOfVisibleListings } }}
                    </span>
                </ng-template>
            </div>
        </div>

        <div class="slide-hover-data">
            <div class="slide-img-container">
                <div class="slide-img-layer"></div>
                <div class="slide-img" *ngIf="postingResource.isUsingDefaultImage !== true" [style.background-image]="'url(' + postingResource.image.smallUrl + ')'"></div>
                <div class="slide-img no-image" *ngIf="postingResource.isUsingDefaultImage === true">
                    <mat-icon class="bg-icon" aria-hidden="true" svgIcon="bg_illustration"> </mat-icon>
                </div>
            </div>
            <div class="slide-content">
                <mat-chip-set tabIndex="-1">
                    <mat-chip class="accent-500" [disableRipple]="true">{{ postingResource.postingType.displayNameKeySingular | translate }}</mat-chip>
                </mat-chip-set>
                <h3 tabindex="0">{{ postingResource.translation.title | translate }}</h3>
                <div class="posting-description" [innerHTML]="postingResource.translation.description | markdown"></div>
                <mat-chip-set
                    class="custom-offering-chip-set white-tag-chip-set mt-16 mb-16"
                    fxLayout="row wrap"
                    fxLayoutAlign="start center"
                    tabindex="0"
                    attr.aria-label="{{ 'PAGE.SETTINGS.TAB.CUSTOM_OFFERING_PROPERTIES.TITLE' | translate }}"
                    *ngIf="customOfferingPropertyChips.length"
                >
                    <mat-chip *ngFor="let chip of visibleCustomOfferingPropertyChips" [disableRipple]="true"> {{ chip.label }}: {{ chip.value }} </mat-chip>

                    <mat-chip
                        *ngIf="hiddenCustomOfferingPropertyCount > 0"
                        class="pointer custom-offering-overflow-chip"
                        [disableRipple]="true"
                        [matTooltip]="hiddenCustomOfferingPropertiesTooltip"
                        matTooltipClass="custom-offering-properties-tooltip"
                        [matTooltipShowDelay]="300"
                    >
                        +{{ hiddenCustomOfferingPropertyCount }}
                    </mat-chip>
                </mat-chip-set>
                <div class="mt-16 btn-container" fxLayoutAlign="flex-end" *ngIf="postingResource.url">
                    <app-flat-button
                        class="w-full"
                        attr.aria-label="{{ 'GENERAL.LABEL.OPEN_POSTING' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
                        [label]="postingResource.postingType.actionButtonTextKey"
                        (onClick)="openPostingUrl(postingResource)"
                    ></app-flat-button>
                </div>
            </div>
        </div>
    </div>
</div>
